<template>
    <div class="exercise_show">
        <!-- 教案列表 -->
        <div v-if="hasData" class="carousel_wrapper">
            <div style="width: 960px;" class="carousel">
                <div class="carousel_box" ref="cardBox" :style="{left: scrollDistance + 'px'}">
                    <cl-card-list ref="exercise" :dragable="dragable" :list="list" :mode="mode" :inline="true" @click="handleClick" @delete="handleDelete">
                    </cl-card-list>
                </div>
            </div>
            <div class="masker" v-show="showMasker">
                <cl-svg-icon class="tu_arrow" @click.native="prev" type="hover" width="34" icon-class="tu_arrow_left">
                </cl-svg-icon>
                <cl-svg-icon class="mt24 tu_arrow" type="hover" @click.native="next" width="34" icon-class="tu_arrow_right">
                </cl-svg-icon>
            </div>
        </div>
        <cl-no-data v-if="!hasData" :show-img="false"></cl-no-data>
        <!-- 教案详情 -->
        <div class="exercise_detail" v-if="showDetail">
            <cl-svg-icon class="taggle" @click.native="showDetail = false" width="34" :currentColor="false" icon-class="tu_arrow_top">
            </cl-svg-icon>
            <cl-ex-detail :ex-data="exDetail"></cl-ex-detail>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'cl-exercise-show',
        data() {
            return {
                showDetail: false, // 是否展示教案详情
                exDetail: {}, // 教案详情数据
                moveStep: 192, // 每次移动距离
                scrollDistance: 0, // 滚动距离
            };
        },

        props: {
            list: Array,
            mode: String,
            rowNum: { // 一行显示几个
                type: Number,
                default: 5
            },
            dragable: Boolean, // 是否可拖拽
        },

        mounted() {},

        computed: {
            // 是否展示切换更多按钮
            showMasker() {
                return this.list.length > this.rowNum;
            },
            // 有数据
            hasData() {
                return this.list.length;
            },
            // 走马灯整体宽度 
            cardBoxW() {
                let el = this.$refs.cardBox;
                return el.clientWidth;
            }
        },

        methods: {
            // 上一个
            prev() {
                if (this.scrollDistance == 0) return; // 到最左边的时候 位置不变
                this.scrollDistance = this.scrollDistance + this.moveStep;
            },
            // 下一个
            next() {
                let num = (this.cardBoxW - Math.abs(this.scrollDistance)) / this.moveStep;
                if (num === 5) return; // 最后一组出现的时候 位置不变
                this.scrollDistance = this.scrollDistance - this.moveStep;
            },
            // 点击查看某个教案
            handleClick(item) {
                if (item.checked) {
                    this.exDetail = item;
                    this.showDetail = true;
                    // this.$server.getExerciseInfo({
                    //     exerciseId: item.id
                    // }).then((res) => {
                    //     this.exDetail = res.data;
                    //     this.showDetail = true;
                    // })
                } else {
                    this.showDetail = false;
                }
            },
            // 删除教案
            handleDelete(item) {
                this.$emit('delete', item);
            },
            // 获取排序后的教案
            getSortedExercises() {
                return this.$refs.exercise.dataList;
            }
        }
    }
</script>
<style lang='scss' scoped>
    .exercise_show {
        .carousel_wrapper {
            display: flex;
            align-items: center;
            .masker {
                flex: 1;
                height: 100%;
                background: linear-gradient(270deg, #FFFFFF 56.96%, rgba(255, 255, 255, 0) 100%);
                z-index: 2;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
        }
        .carousel {
            position: relative;
            overflow: hidden;
            height: 320px;

            .carousel_box {
                height: 100%;
                white-space: nowrap; // 空白处理，不换行
                position: absolute;
                top: 0;
                left: 0;
                transition: left 0.3s;
            }
        }

        .exercise_detail {
            position: relative;

            .taggle {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }

    .tu_arrow.svg-icon {
        background-color: #F3F5F9;
        border-radius: 6px;
        color: #B7B7BF;
        border-radius: 50%;
        &:hover{
            background-color: #3663E1;
            stroke: #fff!important;
        }
    }
</style>